import { jsx as _jsx } from "react/jsx-runtime";
import './Badge.scss';
export const Badge = (props) => {
    let className = '';
    className += props.type ? ` sg-badge-${props.type}` : '';
    className += props.isStrong ? ' sg-badge-strong' : '';
    className += props.unsafeClassName ? ` ${props.unsafeClassName}` : '';
    return _jsx("span", { className: 'sg-badge' + className, children: props.children });
};
//# sourceMappingURL=Badge.js.map